import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { MessageService } from "../message.service";
import { environment } from "../../environments/environment";
import { ArticleService } from "../service/article.service";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { NavComponent } from "../nav/nav.component";
import { HomeLeftScreenComponent } from "../home-left-screen/home-left-screen.component";
import { NewScreenTwoComponent } from "../new-screen-two/new-screen-two.component";
import { NewScreenFourComponent } from "../new-screen-four/new-screen-four.component";
import { NewScreenFiveComponent } from "../new-screen-five/new-screen-five.component";
import { NewScreenSixComponent } from "../new-screen-six/new-screen-six.component";
import { NewScreenSevenComponent } from "../new-screen-seven/new-screen-seven.component";
import { SurgeryHomeComponent } from "../surgery-home/surgery-home.component";
import { FooterComponent } from "../footer/footer.component";

@Component({
  selector: "app-new-home",
  templateUrl: "./new-home.component.html",
  styleUrls: ["./new-home.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatProgressSpinner,
    MatButton,
    MatIcon,
    NavComponent,
    HomeLeftScreenComponent,
    NewScreenTwoComponent,
    NewScreenFourComponent,
    NewScreenFiveComponent,
    NewScreenSixComponent,
    NewScreenSevenComponent,
    SurgeryHomeComponent,
    FooterComponent
  ]
})
export class NewHomeComponent implements OnInit {
  exclusive: any = [];
  exclusive_story: any = {};
  exclusive_story2: any = {};
  exclusive_story3: any = {};
  top_stories: any = [];
  top_storiesa: any;
  should_not = [];
  private curatedTopStories = false;
  nf: any = true;
  title = "TheRightDoctors";
  allarticles: any = [];
  top: any = [];
  popular: any = [];
  topimpact: any = [];
  image: any = [];
  pr: any = [];
  public imageSources: string[] = [];
  loading = false;
  private days: any = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ];
  current_day: string = this.days[new Date().getDay()];

  item: any;
  item2: any;
  v: boolean;
  accepts: boolean;
  key: any;
  pop: boolean;
  v2: boolean;
  key2: any;
  id: any;
  id2: any;

  constructor(
    private titleService: Title,
    private service: ArticleService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef
  ) {
    if (this.current_day === "Wednesday") {
      this.current_day = "Wednesdaay";
    }

    this.item = localStorage.getItem("Item 1");
    this.item2 = localStorage.getItem("Item 2");
    if (this.item == null) {
      this.v = false;
      this.accepts = false;
    } else {
      this.v = true;
      this.accepts = true;
    }
  }

  ngOnInit() {
    this.loading = true;
    if (this.messageService.checksupport()) {
      console.log("your browser supports firebase cloud messaging");
      this.messageService.getPermission();
      this.messageService.receiveMessage();
      this.messageService.currentMessage;
      console.log("Firebase Message New ", this.messageService.currentMessage);
    } else {
      console.log("your browser doesn't support firebase cloud messaging");
    }
    this.titleService.setTitle("Insights from the World's Best Medical Minds");
    this.setArticles();
    this.id = setTimeout(() => {
      if (this.item == null) {
        this.v = false;
        this.accepts = false;
        this.key = "Item 1";
        let myObj = { name: "Skip" };
        localStorage.setItem(this.key, JSON.stringify(myObj));
        if (this.item2 == null) {
          this.v = true;
          this.accepts = true;
          this.pop = true;
          this.v2 = false;
          this.key2 = "Item 2";
          let myObj2 = { name: "Skip2" };
          localStorage.setItem(this.key2, JSON.stringify(myObj2));
        }
      } else {
        this.v = true;
        this.accepts = true;
        if (this.item2 == null) {
          this.pop = true;
          this.v2 = false;
          this.key2 = "Item 2";
          let myObj2 = { name: "Skip2" };
          localStorage.setItem(this.key2, JSON.stringify(myObj2));
        }
      }
    }, 10000);
    this.id2 = setTimeout(() => {
      this.pop = false;
      this.v2 = true;
    }, 20000);
  }
  ngOnDestroy() {
    if (this.id) {
      clearInterval(this.id);
    } else if (this.id2) {
      clearInterval(this.id2);
    }
  }

  setArticles() {
    this.should_not = [];
    let pending = 2;
    const done = () => {
      if (--pending === 0) {
        // Both calls have resolved, so should_not (the hero blocks 1/2/3,
        // populated by exclusiveStory) is now complete. Applying the top-stories
        // filter here makes it deterministic — fixes the race where top-stories
        // sometimes duplicated the hero blocks depending on which call returned first.
        this.applyTopStoriesFilter();
        this.loading = false;
      }
    };
    this.get_topStories(done);
    this.exclusiveStory(done);
    this.applyCuration();
  }

  // Editor-curation overlay for the TOP STORIES list (SSR-safe override-with-guard).
  // Hero blocks stay on the existing homepage-config (block1/2/3) system; only the
  // top-stories list is curated here. Empty/error → the auto list stays (zero regression).
  applyCuration() {
    this.service.getPageLayoutCached("homepage").subscribe(
      (res: any) => {
        const sections = (res && res.data && res.data.sections) || [];
        const sec = sections.find((s: any) => s && s.key === "top-stories");
        if (sec && Array.isArray(sec.articles) && sec.articles.length) {
          this.top_stories = sec.articles.map((story: any) => ({
            ...story,
            href_link: this.buildHrefLink(story)
          }));
          this.curatedTopStories = true;
        }
        this.cdr.markForCheck();
      },
      () => {}
    );
  }

  applyTopStoriesFilter() {
    if (this.curatedTopStories) return; // editor-curated top-stories wins the race
    if (!this.top_storiesa) return;
    this.top_stories = this.top_storiesa
      .filter(story => !this.should_not.includes(story["slug"]))
      .map(story => ({
        ...story,
        href_link: this.buildHrefLink(story)
      }));
    this.cdr.markForCheck();
  }

  get_topStories(onComplete?: () => void) {
    this.service.get_article({ is_top_story: true, limit: 20 }).subscribe(
      data => {
        if (data["success"]) {
          this.nf = false;
          this.top_storiesa = data["data"];
          // filter is applied in applyTopStoriesFilter() from done(), once
          // exclusiveStory has finished populating should_not (race fix)
        } else this.nf = true;
        if (onComplete) onComplete();
        this.cdr.markForCheck();
      },
      () => {
        this.nf = true;
        if (onComplete) onComplete();
        this.cdr.markForCheck();
      }
    );
  }

  exclusiveStory(onComplete?: () => void) {
    // Hero blocks now come from the Page Layout Manager "hero" section (pinned
    // items first, then auto-fill of is_exclusive) — the unified curation system,
    // replacing the old homepage-config block1/2/3 endpoint. Still populates
    // should_not so top-stories excludes the hero (race fix preserved).
    this.service.getPageLayoutCached("homepage").subscribe(
      (res: any) => {
        const sections = (res && res.data && res.data.sections) || [];
        const hero = sections.find((s: any) => s && s.key === "hero");
        const blocks = (hero && Array.isArray(hero.articles) ? hero.articles : []).slice(0, 3);
        if (blocks.length) {
          this.nf = false;
          this.exclusive = blocks.map(story => {
            const href_link = this.buildHrefLink(story);
            this.should_not.push(story["slug"]);
            return { ...story, href_link };
          });
          [
            this.exclusive_story,
            this.exclusive_story2,
            this.exclusive_story3
          ] = this.exclusive;
        } else this.nf = true;
        if (onComplete) onComplete();
        this.cdr.markForCheck();
      },
      () => {
        this.nf = true;
        if (onComplete) onComplete();
        this.cdr.markForCheck();
      }
    );
  }

  buildHrefLink(story) {
    let href_link = environment.frontend_url;
    switch (story["main_category"]) {
      case "insights":
        href_link += `insights/${story["category"]}/${story["blog_category"]}/`;
        break;
      case "podcast":
        href_link += `podcast/${story["event"]}/`;
        break;
      default:
        href_link += `tv/${story["event"]}/${story["category"]}/`;
    }
    return href_link + story["slug"];
  }

  reloadPage() {
    window.location.reload();
  }
}
